import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import { SmallFlatButton } from '../../../tc-ui/small-buttons';
import { FontIcon, IconButton } from 'material-ui';
import RedDot from '../../../tc-ui/redDot';
import FuzzySearch from './fuzzy-search';
import PreciseSearch from './precise-search';

import AdvanceSearchIcon from 'material-ui/svg-icons/image/tune';
import A from 'aphrodite';
const propTypes = {
  searchParams: PropTypes.object,
  search: PropTypes.func,
  updateSearchParams: PropTypes.func,
  listType: PropTypes.string,
  pathBeforeSearch: PropTypes.string,
  updateProps: PropTypes.func,
  changeRoute: PropTypes.func,
};
const styles = A.StyleSheet.create({
  container: { borderBottom: '1px solid rgba(0, 0, 0, 0.1)', display: 'flex', flexDirection: 'column', width: '100%' },
  chips: { paddingBottom: '8px', display: 'flex', marginLeft: '2%' },
  searchStyle: { position: 'relative', display: 'inline-block', marginLeft: '1%', fontSize: '11px', height: '24px', lineHeight: '24px', cursor: 'pointer', width: '104px' },
});
class FilterAndSearch extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { searchParams, search, updateSearchParams, listType, pathBeforeSearch } = this.props;
    const searchFiltersSelected = [
      'locationSearchInput',
      'companySearchInput',
      'stateFilterForBuyer',
      'stateFilterForSupplier',
      'rateConversionStatusFilter',
      'contractTypeFilter',
      'readUnreadFilter',
      'newActivity',
      'otherSideRead',
      'showRateContainers',
      'showArchivedDeleted',
    ]
    .reduce((result, key) => {
      if (R.is(Array, searchParams[key])) {
        if (!R.isEmpty(searchParams[key])) result.push(key);
      } else if (searchParams[key]) result.push(key);
      return result;
    }, []);
    return (
      <div className={A.css(styles.container)}>
        {
          searchParams.openAdvanceSearch ? (
            <div className="flex-tc-sb" style={{ position: 'relative', top: '1px' }}>
              <div/>
              <div className="flex-tc-sb">
                <SmallFlatButton
                  label="Clear Search"
                  labelStyle={{ padding: '0 8px' }}
                  icon={<FontIcon className="tc-icon-close" style={{ margin: '0 0 0 8px' }} />}
                  onTouchTap={() => {
                    this.props.changeRoute(pathBeforeSearch || 'recent');
                  }}
                />
                <SmallFlatButton
                  label="Minimize Search"
                  labelStyle={{ padding: '0 8px' }}
                  style={{ marginLeft: '8px' }}
                  icon={<AdvanceSearchIcon style={{ margin: '0 0 0 8px' }} />}
                  onTouchTap={() => updateSearchParams({ openAdvanceSearch: false })}
                />
              </div>
            </div>
          ) : (
            <div className="flex-tc-sb" style={{ position: 'relative', top: '1px' }}>
              <FuzzySearch updateSearchParams={updateSearchParams} search={search} searchParams={searchParams} changeRoute={this.props.changeRoute} />
              <IconButton
                tooltip={!searchParams.openAdvanceSearch ? 'Advance Search' : 'Hide advance search'}
                onTouchTap={() => updateSearchParams({ openAdvanceSearch: true })}
              >
              <span>
                <AdvanceSearchIcon/>
                { Boolean(listType === 'search' && searchFiltersSelected.length && !searchParams.openAdvanceSearch) && <RedDot style={{ top: '-36px', left: '7px' }}/>}
              </span>
              </IconButton>
            </div>
          )
        }
        {
          searchParams.openAdvanceSearch && (
            <PreciseSearch updateSearchParams={updateSearchParams} search={search} searchParams={searchParams} />
          )
        }
      </div>
    );
  }
}

const mapStateToProps = ({ contracting, user }) => ({
  pathBeforeSearch: contracting.contractList.get('pathBeforeSearch'),
  searchParams: contracting.contractList.get('searchParams').toJS(),
  listType: contracting.contractList.getIn(['list', 'listType']),
  companyType: user.getIn(['user', 'type']),
});

FilterAndSearch.propTypes = propTypes;

export default connect(mapStateToProps)(FilterAndSearch);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/top-bar/filters-search.jsx